import Vue from "vue";

Vue.filter("trimAll", function(string)
{
    return string.replace(/ /g, "");
});
